module.exports = __webpack_public_path__ + "img/doctor_icon.9dafe9da.png";